/* Staging Environment Configuration */

module.exports = {
  ENV_NAME: 'staging',
  APP_TEST_MODE: false,  // Set to false to enable all features (SMS, emails, etc.)
  API_URL: 'https://staging.uniservice.in/api',
  ADMIN_CORNER_URL: 'https://staging.admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://staging-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://staging-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
}



// WEBPACK FOOTER //
// ./src/config/env.staging.js